module.exports = __webpack_public_path__ + "img/ico_dome_on.230b64ba.svg";